import React from 'react';

import { DrawStructureEnum, EventTypeEnum } from '@clubspark-node/clubspark-tennis-types';
import { useAtomValue } from 'jotai';
import { useParams } from 'react-router-dom';

import {
  eventAlternateDrawParticipantsAtomFamily,
  eventAlternateTeamParticipantsAtomFamily,
  eventAtomFamily,
  eventMainDrawParticipantsAtomFamily,
  eventMainTeamParticipantsAtomFamily,
} from 'atoms/events';
import AvoidancePanelContainer from 'containers/eventsSplitDraws/avoidance/AvoidancePanel';

import ActiveCompetitorsSection from './ActiveCompetitorsSection';
import DoublesCompetitorsSection from './DoublesCompetitorSection';
import WithdrawnCompetitorsSection from './WithdrawnCompetitorsSection';

const EntriesPanel: React.FC = React.memo(() => {
  const { eventId } = useParams<{ eventId: string }>();

  const event = useAtomValue(eventAtomFamily(eventId));
  const isDoubles = event?.eventType === EventTypeEnum.DOUBLES;
  const isTeam = event?.eventType === EventTypeEnum.TEAM;
  const isAdHoc = event?.drawDefinitions?.[0]?.drawType === DrawStructureEnum.AD_HOC;

  return (
    <>
      {!isAdHoc && <AvoidancePanelContainer />}

      <ActiveCompetitorsSection
        alternateParticipantsAtom={eventAlternateDrawParticipantsAtomFamily(eventId)}
        selectedParticipantsAtom={eventMainDrawParticipantsAtomFamily(eventId)}
      />
      {isTeam && (
        <ActiveCompetitorsSection
          isTeamPlayersTable
          alternateParticipantsAtom={eventAlternateTeamParticipantsAtomFamily(eventId)}
          selectedParticipantsAtom={eventMainTeamParticipantsAtomFamily(eventId)}
        />
      )}
      {isDoubles && <DoublesCompetitorsSection />}
      <WithdrawnCompetitorsSection />
    </>
  );
});

export default EntriesPanel;
